import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const VerifyUserToken = () =>
	axios.get(`${apiUrl}/VerifyUserToken.ashx`);

export const LogoutUser = () => axios.get(`${apiUrl}/LogoutUser.ashx`);

/*
export const TestCookie = () => {
	return axios.get(`${apiUrlCore}/form/test-cookie`, { withCredentials: true });
};
*/